module.exports = __webpack_public_path__ + "media/images/Laura_Flight-0ff01b4ecab83a5f1044849d4c39cfcc.jpg";